module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("The Sleepless Stars")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("A Novel of Fatal Insomnia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("CJ Lyons")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('b', [_vm._v("PRAISE FOR "), _c('i', [_vm._v("NEW YORK TIMES")]), _vm._v(" BESTSELLER CJ LYONS' THRILLERS WITH HEART:")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Everything a great thriller should be—action packed, authentic, and intense.” "), _c('i', [_vm._v("~New York Times bestselling author Lee Child")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“A compelling voice in thriller writing…I love how the characters come alive on every page.” "), _c('i', [_vm._v("~New York Times bestselling author Jeffery Deaver  ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Top Pick! A fascinating and intense thriller.” "), _c('i', [_vm._v("~RT Book Reviews")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“An intense, emotional thriller…(that) climbs to the edge of intensity.” "), _c('i', [_vm._v("~National Examiner")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“A perfect blend of romance and suspense.  My kind of read.”")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('i', [_vm._v("~New York Times Bestselling author Sandra Brown")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Highly engaging characters, heart-stopping scenes…one great rollercoaster ride.” "), _c('i', [_vm._v("~Bookreporter.com")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Adrenalin pumping.” "), _c('i', [_vm._v("~The Mystery Gazette")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Riveting.” "), _c('i', [_vm._v("~Publishers Weekly")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Lyons “is a master within the genre.” "), _c('i', [_vm._v("~Pittsburgh Magazine")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“A great fast-paced read….Not to be missed.” "), _c('i', [_vm._v("~Book Addict")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Characters with beating hearts and three dimensions.” "), _c('i', [_vm._v("~Newsday")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“A pulse-pounding adrenalin rush!”")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('i', [_vm._v("~New York Times bestselling author Lisa Gardner")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“…Harrowing, emotional, action-packed and brilliantly realized.”")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('i', [_vm._v("~New York Times bestselling author Susan Wiggs")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("“Explodes on the page…I absolutely could not put it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_c('i', [_vm._v("~Romance Readers' Connection")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously. Other names, characters, places, and incidents are the product of the author’s imagination, and any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Copyright 2016, CJ Lyons, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Edgy Reads")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Cover art: Toni McGee Causey, stock image courtesy of NASA/ESA/Hubble")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("All rights reserved, including the right of reproduction in whole or in part in any form. This book, or parts thereof, may not be reproduced in any form without permission in writing from the publisher, Edgy Reads. The scanning, uploading and distribution of this book via the Internet or via any other means without the permission of the publisher is illegal and punishable by law.")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("CJ Lyons and Thrillers with Heart trademarked by CJ Lyons, LLC")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("Library of Congress Case Number 1-3490426461")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab6ffa3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-sleepless-stars.vue
// module id = 66
// module chunks = 0